jQuery(document).ready(function($) {
    var $window = $(window),
        $menuItems = $('#footer-menu > li.menu-item-has-children > a'),
        mobileBreakpoint = 768;

    function handleMenu() {
        if ($window.width() <= mobileBreakpoint) {
            // Mobile behavior
            //$('#footer-menu > li.menu-item-has-children .sub-menu').hide();
            
            // Use touchstart for better mobile response
            $menuItems.off('click touchstart').on('click touchstart', function(e) {
                e.preventDefault();
                e.stopPropagation(); // Prevent event bubbling
                
                // Simply toggle the clicked submenu without affecting others
                $(this).siblings('.sub-menu').slideToggle();
                return false;
            });
        } else {
            // Desktop behavior
            $menuItems.off('click touchstart');
            //$('#footer-menu > li.menu-item-has-children .sub-menu').show();
            
            // Restore original href attributes if they exist
            $menuItems.each(function() {
                var $this = $(this);
                if ($this.data('original-href')) {
                    $this.attr('href', $this.data('original-href'));
                }
            });
        }
    }

    // Initial setup
    handleMenu();

    // Use debounced resize handler to prevent excessive calls
    var resizeTimer;
    $window.on('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(handleMenu, 250);
    });
});